export default __webpack_public_path__ + "static/media/momni_mobile.027177d1.jpg";